import request from '@/utils/request'

// 查询是否登录调取supplierCode接口
export function qryShopDetails (data) {
  return request({
    url: '/apis/sra/store/users/signup/qryShopDetails', // 后端接口
    method: 'post',
    data
  })
}

// 查询店铺审批详情接口
export function qryShopDetailById (data) {
  return request({
    url: '/apis/sra/store/users/signup/qryShopDetailById', // 后端接口
    method: 'post',
    data
  })
}
